export default "__VITE_ASSET__4nPkoev7__"